import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../interfaces';
import { showModal, hideModal } from '../../redux/slices/modal';
import { API_KEYS } from '../../interfaces/api';
import { getApiState } from '../../redux/selectors/common';
import { thunks } from '../../redux/thunks/thunks';
import ResetPinOtp from './ResetPinOtp';
import { resetApiThunk } from '../../redux/thunks/api';

const mapState = (state: AppState) => ({
  modal: state.modal,
  auth: getApiState(state, API_KEYS.LOGIN),
  resendOtpState: getApiState(state, API_KEYS.RESEND_OTP),
  verifyOtpState: getApiState(state, API_KEYS.WALLETPIN_VERIFY_OTP),
  resetPinState: getApiState(state, API_KEYS.RESET_WALLET_PIN),
});

const mapDispatch = {
  resetApi: resetApiThunk,
  showModal,
  hideModal,
  resendOtp: thunks.RESEND_OTP,
  verifyOtp: thunks.WALLETPIN_VERIFY_OTP,
  resetPin : thunks.RESET_WALLET_PIN
  
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ResetPinOtp);
